module.exports = __webpack_public_path__ + "img/prescriptionMap.3357560e.png";